/**
 * Lightweight formatting helpers shared across the billing admin pages.
 * Currency uses Intl.NumberFormat for locale-aware grouping/symbols.
 */

export function formatCurrency(amountCents, currency = 'USD') {
  const amount = (Number(amountCents) || 0) / 100;
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency || 'USD',
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${currency} ${amount.toFixed(2)}`;
  }
}

export function formatNumber(n) {
  const num = Number(n);
  if (!isFinite(num)) return '—';
  return num.toLocaleString();
}

export function formatCompactNumber(n) {
  const num = Number(n);
  if (!isFinite(num)) return '—';
  if (Math.abs(num) >= 1_000_000) return `${(num / 1_000_000).toFixed(1)}M`;
  if (Math.abs(num) >= 1_000) return `${(num / 1_000).toFixed(1)}k`;
  return num.toLocaleString();
}

export function formatDate(value, opts) {
  if (!value) return '—';
  try {
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) return String(value);
    return d.toLocaleString(
      undefined,
      opts || { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }
    );
  } catch {
    return String(value);
  }
}

export function formatDateOnly(value) {
  return formatDate(value, { year: 'numeric', month: 'short', day: 'numeric' });
}

export function formatBytes(mb) {
  const num = Number(mb);
  if (!isFinite(num)) return '—';
  if (num >= 1024) return `${(num / 1024).toFixed(2)} GB`;
  return `${num.toLocaleString(undefined, { maximumFractionDigits: 2 })} MB`;
}

export const KIND_LABELS = {
  per_query: 'Per query',
  per_mb_payload: 'Per MB payload',
  per_1k_tokens: 'Per 1K tokens',
  flat_monthly: 'Flat monthly',
  flat_yearly: 'Flat yearly',
};

export function kindLabel(kind) {
  return KIND_LABELS[kind] || (kind ? String(kind).replace(/_/g, ' ') : '—');
}
